"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightSeatsTariffEdit = exports.className = void 0;
const react_1 = __importStar(require("react"));
const TariffsTable_1 = require("../../../TariffsTable");
const LabelColumn_1 = require("./LabelColumn");
const TariffColumn_1 = require("./TariffColumn");
require("./index.scss");
exports.className = 'flight-seats-tariff-edit';
const FlightSeatsTariffEdit = (props) => {
    const { tariffGroups, propsValues, onValue, config, setValidateRef } = props;
    const validatorsRef = (0, react_1.useRef)([]);
    if (tariffGroups.length !== validatorsRef.current.length) {
        validatorsRef.current = tariffGroups.map(() => (() => false));
    }
    setValidateRef === null || setValidateRef === void 0 ? void 0 : setValidateRef(() => validatorsRef.current.map(x => x()).every(x => x));
    return (react_1.default.createElement(TariffsTable_1.TariffsTable, null,
        react_1.default.createElement(LabelColumn_1.FlightSeatsLabelColumn, { config: config }),
        tariffGroups.map((tariffGroup, i) => {
            const columnProps = {
                tariffGroup,
                config,
                propsValues: propsValues === null || propsValues === void 0 ? void 0 : propsValues.find(x => { var _a; return ((_a = x.tariffGroup) === null || _a === void 0 ? void 0 : _a.id) === tariffGroup.id; }),
                onChange: (values) => {
                    const newValuesList = (propsValues !== null && propsValues !== void 0 ? propsValues : [])
                        .filter(x => { var _a, _b; return ((_a = x.tariffGroup) === null || _a === void 0 ? void 0 : _a.id) !== ((_b = values.tariffGroup) === null || _b === void 0 ? void 0 : _b.id); });
                    newValuesList.push(values);
                    onValue(newValuesList);
                },
                setValidateRef: (x) => validatorsRef.current[i] = x,
            };
            return (react_1.default.createElement(TariffColumn_1.FlightSeatsTariffColumn, { ...columnProps, key: i }));
        })));
};
exports.FlightSeatsTariffEdit = FlightSeatsTariffEdit;
//# sourceMappingURL=index.js.map